module.exports = __webpack_public_path__ + "img/pointarea.1e581b4c.svg";